import React from "react";

const Mindfulness = () => <div />;
export default Mindfulness;
